import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { AuditService, ConfigService, StoreConfig } from 'ngx-web-api';
import { ItemEditorService } from 'app/core/services/item-editor.service';
import { ViewportService } from 'app/core/services/viewport.service';
import { ItemEditorModalContext } from 'app/domain/item-editor-modal-context';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EMPTY, from, Subject } from 'rxjs';
import { mergeMap, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fts-item-editor-modal',
  templateUrl: './item-editor-modal.component.html',
  styleUrls: ['./item-editor-modal.component.scss'],
})
export class ItemEditorModalComponent implements OnInit, OnDestroy {
  @ViewChild('editor', { read: ViewContainerRef, static: true })
  private editor: ViewContainerRef;
  public context: ItemEditorModalContext;
  storeConfig: StoreConfig;
  itemOrdinalId: number;
  itemName: string;
  finishLoading = false;
  editorLoaded = false;
  orderedItemHasWarnings: boolean;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private configService: ConfigService,
    public viewportService: ViewportService,
    private itemEditorService: ItemEditorService,
    private auditService: AuditService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.auditService.createAudit(() => `Item Editor modal has been opened`);
    this.configService.storeConfig$.pipe(take(1)).subscribe((config: StoreConfig) => (this.storeConfig = config));
    this.itemOrdinalId = this.context.itemOrdinalId;
    this.itemEditorService.editingItem$.pipe(takeUntil(this.destroy$)).subscribe(editingItem => {
      if (!!editingItem?.orderedItem) {
        this.orderedItemHasWarnings = !!editingItem.orderedItem.warnings;
      }
      if (!!editingItem?.orderableItem) {
        this.itemName = editingItem.orderableItem?.name;
      }
    });
    this.loadEditor();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFinishLoading(finishLoading: boolean) {
    this.finishLoading = finishLoading;
  }

  // The editor is downloaded on first use, to keep it out of the initial bundle
  private loadEditor(): void {
    from(import('../../item-editor/editor-modal-content'))
      .pipe(
        mergeMap(({ OrderedEditorComponent, OrderableEditorComponent }) => {
          if (!!this.itemOrdinalId) {
            const orderedEditor = this.editor.createComponent(OrderedEditorComponent).instance;
            orderedEditor.inItemEditorModal = true;
            orderedEditor.itemOrdinalId = this.itemOrdinalId;
            this.editorLoaded = true;
            return orderedEditor.finishLoading;
          }
          this.editor.createComponent(OrderableEditorComponent).instance.inItemEditorModal = true;
          this.editorLoaded = true;
          return EMPTY;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (finishLoading: boolean) => this.onFinishLoading(finishLoading),
        error: error => {
          this.activeModal.close();
        },
      });
  }
}
